import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import {
  AccordionSummary,
  Box,
  Card,
  Container,
  Grid,
  Icon,
  Typography,
} from '@material-ui/core';
import { Row } from 'components/Row';
import { CustomButton } from 'components/CustomButton';
import {
  createAditivoDescentralizadoRoute,
  createDistratoDescentralizadoRoute,
  modelosDocumentosContratoRoute,
} from 'library/Routes';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import {
  CONTRATO_ETAPAS_PARAMS_URL,
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  TipoContrato,
  TipoFluxo,
  VersaoContratoEnum,
  URL_ENTE_DESCENTRALIZADO,
  URL_ADITIVO_PARAM,
  URL_DISTRATO_PARAM,
} from 'models/contratos';
import ControlledAccordions from 'pages/Contratos/components/Accordion';
import { CreateRouteParams, EditRouteParams } from '../../__types';
import { loadContratoEntePublico, openModalEntePublicoAditivo, openModalEntePublicoDistrato } from 'store/modules/ContratosFluxoDescentralizado/EntePublico/EntePublicoActions';
import { loadCidadesByEstadoId, loadEstados } from 'store/modules/LogradouroActions';
import SnackbarUtils from 'utils/SnackbarUtils';
import { loadContratoAdendos, resetFiltersDocumento } from 'store/modules/AllContratos/AllContratosActions';
import '../../index.scss'
interface Cidade {
  nome: string;
}

export const DocumentoEntePublicoDescentralizado = () => {
  const [tipoFluxoFilter, setTipoFluxoFilter] = useState<number | null>(null);
  const [tipoEnteFilter, setTipoEnteFilter] = useState<number | null>(null);
  const languageValues = useSelector(
    (states: RootState) => states.languages.languageValues
  );
  const contratoEntePublicoReducer = useSelector(
    (state: RootState) => state.contratosDescentralizadosEntePublico.contratoEditing
  );
  const adendoAll = useSelector(
    (state: RootState) => state.allContratos.adendosAll
  );
  const adendoObject = useSelector(
    (state: RootState) => state.allContratos.adendoObject
  );
  const logradouro = useSelector((state: RootState) => state.logradouro);

  const programasFilter =
    contratoEntePublicoReducer.programasEducacionais;

  const params = useParams<CreateRouteParams & EditRouteParams>();
  const id = params.id || null;
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const fluxoEntePublico = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO);

  const getUFByIdEstado = useCallback((idEstadoParam: number | null): string => {
    const estadoV = logradouro.estados.find((estado) => estado.id === idEstadoParam);
    return estadoV ? estadoV.sigla : '';
  }, [logradouro.estados]);


  const loadEstadosAll = useCallback(() => {
    dispatch(loadEstados(
      () => {
        const idEstado = contratoEntePublicoReducer.idEstado;
        if (idEstado) {
          loadCidades(idEstado);
        }
      },
      (error: any) => {
        SnackbarUtils.enqueueSnackbar({
          message: error.response.statusText || languageValues.errorLoadEstados,
          options: {
            variant: 'error',
          },
        });
      }
    ));
    // eslint-disable-next-line
  }, [dispatch, contratoEntePublicoReducer.idEstado, languageValues.errorLoadEstados]);

  const loadCidades = (idEstado: number) => {
    const uf = getUFByIdEstado(idEstado);
    if (uf && getCidades(uf).length === 0) {
      dispatch(loadCidadesByEstadoId(idEstado, uf));
    }
  };

  const getCidades = (uf: string): Cidade[] => {
    if (!uf) {
      return [];
    }
    return logradouro.cidades[uf.toLowerCase()] || [];
  };

  useEffect(() => {
    loadEstadosAll()
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (id && fluxoEntePublico) {
      dispatch(loadContratoAdendos(Number(id)));
    }
  }, [dispatch, fluxoEntePublico, id]);

  useEffect(() => {
    dispatch(resetFiltersDocumento());
    const urlAtual = window.location.href;

    const isEntePublico = () => {
      return urlAtual.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO) &&
        !urlAtual.includes(URL_ADITIVO_PARAM.EDICAO_ADITIVO) &&
        !urlAtual.includes(URL_ADITIVO_PARAM.CADASTRO_ADITIVO) &&
        !urlAtual.includes(URL_DISTRATO_PARAM.EDICAO_DISTRATO) &&
        !urlAtual.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO);
    };

    if (isEntePublico() && fluxoEntePublico) {
      setTipoFluxoFilter(TipoFluxo.DESCENTRALIZADO);
      setTipoEnteFilter(TipoContrato.ENTE_PUBLICO);
      dispatch(loadContratoEntePublico(Number(id), VersaoContratoEnum.CONTRATO));
    }
  }, [dispatch, fluxoEntePublico, id]);

  const handleDocumentoParams = () => {
    const filters = {
      tipoFluxo: tipoFluxoFilter,
      tipoContrato: tipoEnteFilter,
      programa: programasFilter,
    };
    localStorage.setItem('documentoFiltersEntePublico', JSON.stringify(filters));
    const url = `${modelosDocumentosContratoRoute.path}?busca=true`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    const { pathname } = location;
    switch (true) {
      case pathname.includes(URL_ADITIVO_PARAM.CADASTRO_ADITIVO):
      case pathname.includes(URL_ADITIVO_PARAM.MODAL_EDICAO_ADITIVO):
        dispatch(openModalEntePublicoAditivo());
        break;
      case pathname.includes(URL_DISTRATO_PARAM.CADASTRO_DISTRATO):
      case pathname.includes(URL_DISTRATO_PARAM.MODAL_EDICAO_DISTRATO):
        dispatch(openModalEntePublicoDistrato());
        break;
      default:
        break;
    }
  }, [dispatch, location, location.pathname, params.idAditivo, params.idDistrato]);

  return (
    <>
      <Container className='componentsDescentralizado__container'>
        <Box className='componentsDescentralizado__box'>
          <Typography
            variant='h5'
            className='componentsDescentralizado__title'
          >
            {languageValues.documentos}
          </Typography>
          <Typography
            variant='h6'
            className='componentsDescentralizado__sub'
          >
            {languageValues.facaDownloadEUploadContrato}
          </Typography>
        </Box>
      </Container>

      <Card className='componentsDescentralizado__card'>
        <AccordionSummary
          className='componentsDescentralizado__accordionSummary'
          expandIcon={<Icon style={{ color: '#FFFFFF' }} />}
        >
          <Grid container spacing={1}>
            <Grid item xs={4} md={4}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title'>
                {languageValues.cadastroContratoCodigo}
              </Typography>
            </Grid>
            <Grid item xs={3} md={3}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title'>
                {languageValues.cadastroContratoVersao}
              </Typography>
            </Grid>
            <Grid item xs={3} md={3}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title'>
                {languageValues.cadastroContratoSituacao}
              </Typography>
            </Grid>
            <Grid item xs={1} md={1}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title'></Typography>
            </Grid>
            <Grid item xs={1} md={1}>
              <Typography className='componentsDescentralizado__accordionSummary-column-title color-actions'>
                {languageValues.cadastroContratoAcoes}
              </Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <Box>
          <Typography
            variant='h6'
            className='componentsDescentralizado__adendos-title'
          ></Typography>
          {adendoAll.map((adendo) => (
            <ControlledAccordions
              key={adendo.id}
              id={adendo.id}
              ativo={adendo.ativo}
              codigo={adendo.codigo}
              flgStatus={adendo.flgStatus}
              idDocAssinado={adendo.idDocAssinado}
              idDocExtrato={adendo.idDocExtrato}
              idDocPlanoTrabalho={adendo.idDocPlanoTrabalho}
              incluiPlanoTrabalho={adendo.incluiPlanoTrabalho}
              dataAlteracao={adendo.dataAlteracao}
              versaoContrato={adendo.versaoContrato}
            />
          ))}
        </Box>
        <Box>
          <Row>
            <Grid
              container
              spacing={1}
              className='componentsDescentralizado__container-button-route'
            >
              <Grid item>
                <CustomButton
                  theme='pufvYellow'
                  className={'button-route__modelos-documentos'}
                  label={'Modelos de documentos'}
                  disabled={false}
                  onClick={() => {
                    handleDocumentoParams();
                  }}
                />
              </Grid>
              <Grid item>
                <CustomButton
                  theme='pufvYellow'
                  className={'button-route__criar-distrato'}
                  label={'Criar distrato'}
                  onClick={() => {
                    history.push(
                      createDistratoDescentralizadoRoute.getURLWithParams(
                        CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
                        CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
                        id,
                        CONTRATO_PASSOS.DOCUMENTOS
                      )
                    );
                    dispatch(openModalEntePublicoDistrato());
                  }}
                  disabled={!adendoObject.geraDistrato}
                />
              </Grid>
              <Grid item>
                <CustomButton
                  theme='pufvYellow'
                  className={'button-route__criar-aditivo'}
                  label={'Criar aditivo'}
                  onClick={() => {
                    history.push(
                      createAditivoDescentralizadoRoute.getURLWithParams(
                        CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
                        CONTRATO_ETAPAS_PARAMS_URL.EDICAO,
                        id,
                        CONTRATO_PASSOS.DOCUMENTOS
                      )
                    );
                    dispatch(openModalEntePublicoAditivo());
                  }}
                  disabled={!adendoObject.geraAditivo}
                />
              </Grid>
            </Grid>
          </Row>
        </Box>
      </Card>
    </>
  );
};
